import { connect } from 'react-redux';
import { actions } from '../../../../../redux/modules/roles';
import Crear from './Crear';


const ms2p = (state) => {
    return {
        ...state.roles,
    };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Crear);
